import globalAxios from './axiosInstance';

const API_GATEWAY_BASE_URL = process.env.REACT_APP_BLINKPAY_API_GATEWAY_URL;

const camelToSnake = (str: string): string => {
    return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
};

const snakeToCamel = (str: string): string => {
    return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
};

const convertKeysToSnakeCase = (obj: any): any => {
    if (obj === null || obj === undefined) {
        return obj;
    }

    if (obj instanceof Date) {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map(item => convertKeysToSnakeCase(item));
    }

    if (typeof obj === 'object') {
        return Object.keys(obj).reduce((acc, key) => {
            const snakeKey = camelToSnake(key);
            acc[snakeKey] = convertKeysToSnakeCase(obj[key]);
            return acc;
        }, {} as any);
    }

    return obj;
};

const convertKeysToCamelCase = (obj: any): any => {
    if (obj === null || obj === undefined) {
        return obj;
    }

    if (obj instanceof Date) {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map(item => convertKeysToCamelCase(item));
    }

    if (typeof obj === 'object') {
        return Object.keys(obj).reduce((acc, key) => {
            const camelKey = snakeToCamel(key);
            acc[camelKey] = convertKeysToCamelCase(obj[key]);
            return acc;
        }, {} as any);
    }

    return obj;
};

export const createQuickPayment = async (data: any) => {
    try {
        const snakeCaseData = convertKeysToSnakeCase(data);
        const response = await globalAxios.post(`${API_GATEWAY_BASE_URL}/payments/v1/quick-payments`, snakeCaseData);
        console.log('Quick payment triggered successfully:', response.data);
        return convertKeysToCamelCase(response.data);
    } catch (error) {
        console.error('Error triggering quick payment:', error);
        throw error;
    }
};

export const createSingleConsent = async (data: any) => {
    try {
        const snakeCaseData = convertKeysToSnakeCase(data);
        const response = await globalAxios.post(`${API_GATEWAY_BASE_URL}/payments/v1/single-consents`, snakeCaseData);
        console.log('Single consent triggered successfully:', response.data);
        return convertKeysToCamelCase(response.data);
    } catch (error) {
        console.error('Error triggering single consent:', error);
        throw error;
    }
};

export const createEnduringConsent = async (data: any) => {
    try {
        const snakeCaseData = convertKeysToSnakeCase(data);
        const response = await globalAxios.post(`${API_GATEWAY_BASE_URL}/payments/v1/enduring-consents`, snakeCaseData);
        console.log('Enduring consent triggered successfully:', response.data);
        return convertKeysToCamelCase(response.data);
    } catch (error) {
        console.error('Error triggering enduring consent:', error);
        throw error;
    }
};

export const createPayment = async (data: any) => {
    try {
        const snakeCaseData = convertKeysToSnakeCase(data);
        const response = await globalAxios.post(`${API_GATEWAY_BASE_URL}/payments/v1/payments`, snakeCaseData);
        console.log('Payment triggered successfully:', response.data);
        return convertKeysToCamelCase(response.data);
    } catch (error) {
        console.error('Error triggering payment:', error);
        throw error;
    }
};

export const getEnduringConsent = async (consentId: string) => {
    try {
        const response = await globalAxios.get(
            `${API_GATEWAY_BASE_URL}/payments/v1/enduring-consents/${consentId}`
        );
        console.log('Enduring consent retrieved successfully:', response.data);
        return convertKeysToCamelCase(response.data);
    } catch (error) {
        console.error('Error retrieving enduring consent:', error);
        throw error;
    }
};